import 'bootstrap-table/dist/bootstrap-table.min.css';
import 'bootstrap-table/dist/bootstrap-table.js';
import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN.min.js';
import component from 'bootstrap-table/dist/bootstrap-table-vue.esm.js';

export default {
	install(Vue){
		Vue.component('BootstrapTable', component);
	}
}
